import { CircularProgress, Box } from '@mui/material'

const Loader = (props) => {
  return (
    <Box p={15} display="flex" justifyContent="center" padding={props?.padding}>
      <CircularProgress  size={props?.size}/>
    </Box>
  )
}

export default Loader
